import React from 'react';
import './carousel-loading-state.scss';

const CarouselLoadingState = ({ className = '' }: { className?: string }) => (
  <div
    className={`rpm-carousel__placeholder ${className}`}
    data-testid="pet-profile-carousel-loading-state"
  >
    <div className="rpm-carousel__placeholder__header">
      <div className="rpm-carousel__placeholder__header__title" />
      <div className="rpm-carousel__placeholder__header__controls" />
    </div>
    <div className="rpm-carousel__placeholder__wrapper">
      <div className="rpm-carousel__placeholder__item" />
      <div className="rpm-carousel__placeholder__item" />
      <div className="rpm-carousel__placeholder__item" />
      <div className="rpm-carousel__placeholder__item" />
      <div className="rpm-carousel__placeholder__item" />
      <div className="rpm-carousel__placeholder__item" />
    </div>
  </div>
);

export default CarouselLoadingState;
